<template>
  <div class="content edit-page minus-margin20">
    <CommonStep :step-list="stepList"></CommonStep>
    <el-row class="content-2-col" ref="rightForm" id="rightForm">
      <template v-if="showCardStep === 1">
        <template v-if="mode === 'create'">
          <AdCommonOrderForm
            :isShowParent="isShowParent"
            :partnerId="projectOrder.partnerId"
            :createType="createType"
            @go-back="$emit('go-back')"
            @next="goNextStep"
          ></AdCommonOrderForm>
        </template>
        <!--编辑项目订单-->
        <ContentBox title="编辑订单" v-if="mode === 'edit'">
          <el-form
            class="demo-ruleForm"
            ref="orderForm"
            :rules="rules"
            :model="orderForm"
            label-width="125px"
            label-position="left"
            hide-required-asterisk
          >
            <el-form-item label="订单名称" prop="orderName">
              <el-input placeholder="输入订单名称" :value="orderForm.orderName" @input="handleOrderName" maxlength="45" show-word-limit />
            </el-form-item>
            <template v-if="projectOrder.accountType === '1'">
              <el-form-item label="广告主" prop="partnerId">
                <span>{{ orderForm.partnerName }}</span>
              </el-form-item>
            </template>
            <el-form-item label="购买方式">
              <span>合约排期</span>
            </el-form-item>
            <el-form-item label="售卖方式">{{translateSellTypeText[orderForm.sellingType]}}</el-form-item>
            <template v-if="orderForm.sellingType === 1">
              <el-form-item label="下单总量" prop="totalContract" class="flex-form-item">
                <el-radio-group v-model="orderForm.totalContractType" @change="totalContractTypeChange">
                  <el-radio-button :label="1">排期汇总</el-radio-button>
                  <el-radio-button :label="0">自定义</el-radio-button>
                </el-radio-group>
                <el-input v-if="orderForm.totalContractType === 0" placeholder="请输入下单总量" v-model.trim="orderForm.totalContract" clearable>
                  <template slot="append">PV</template>
                </el-input>
              </el-form-item>
            </template>
            <el-form-item label="投放时间" v-if="orderForm.buyType === 0">
              <el-date-picker
                v-model="contractTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="{ disabledDate: disabledDate }"
                @change="handleContractTime"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                自动流量分配
                <el-tooltip class="item" effect="light" placement="top-start">
                  <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                  <div slot="content">选择"是"，则此订单会推送到自动流量分配列表，推送规则为"缺量时推送"</div>
                </el-tooltip>
              </div>
              <el-radio-group v-model="orderForm.pushAuto">
                <el-radio-button :label="1">是</el-radio-button>
                <el-radio-button :label="0">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="客户品牌" prop="customerBrands">
              <MultiAutoComplete
                placeholder="请输入品牌"
                query-api="getSuggestBrands"
                v-model="orderForm.customerBrands"
              />
            </el-form-item>
            <el-form-item label="客户产品" prop="customerProducts">
              <MultiAutoComplete
                placeholder="请输入产品"
                query-api="getSuggestProducts"
                v-model="orderForm.customerProducts"
              />
            </el-form-item>
            <el-form-item label="订单标签" prop="orderTag">
              <CommonSelectPannel
                :leftData="tagList"
                v-model="orderForm.orderTag"
                :selectPanelColumns="['分类', '标签']"
                selectPlaceholder="请输入关键词"
              ></CommonSelectPannel>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                业务员
                <span style="color:rgba(0, 0, 0, 0.65)">(选填)</span>
              </span>
              <el-select v-model="orderForm.adSalesmanIdList" multiple placeholder="请选择业务员" :no-data-text="noSaleman">
                <el-option
                  v-for="item in salesmanList"
                  :key="item.agentAccountId"
                  :label="item.agentAccountName"
                  :value="item.agentAccountId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                备注
                <span style="color:rgba(0, 0, 0, 0.65)">(选填)</span>
              </span>
              <el-input v-model="orderForm.description" clearable></el-input>
            </el-form-item>
            <el-form-item label="投放高质量设备">
              <el-switch v-model="orderForm.ipFilter" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item>
              <template #label>
                IES服务
                <el-tooltip class="item" effect="light" placement="top-start">
                  <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                  <div slot="content">IES开启，计划审核完成后会自动替换IES宏参，并自动获取秒针的监测数据与自有监测数据对比、自动发起预警；
                    关闭后则无法获取秒针监测数据、无法发起自动预警；</div>
                </el-tooltip>
              </template>
              <el-switch v-model="orderForm.iesSwitch" :active-value="1" :inactive-value="0" disabled></el-switch>
            </el-form-item>
          </el-form>
        </ContentBox>
        <ContentBox v-if="mode === 'edit'">
          <el-button plain @click="handleCancel">取消</el-button>
          <el-button plain @click="onEditSubmit('orderForm', 'back')" :loading="saveBtnLoading" :disabled="saveDisable">保存订单</el-button>
          <el-button
            type="primary"
            @click="onEditSubmit('orderForm', 'next')"
            :loading="saveBtnLoading"
            :disabled="saveDisable"
          >保存并创建计划</el-button>
          <el-button type="primary" @click="onEditSubmit('orderForm', 'batch')" :loading="saveBtnLoading" :disabled="saveDisable">保存并批量建单</el-button>
        </ContentBox>
      </template>
      <template v-if="showCardStep === 2">
        <AdCommonForm
          mode="create"
          :order="commonForm"
          :schedule="scheduleForm"
          :cableCheckable="cableCheckable"
          :isLockPreviousStep="isLockPreviousStep"
          @step="getStep(arguments)"
          show-button="true"
          @go-back="$emit('go-back')"
          @add-media="handleAddMedia"
        ></AdCommonForm>
      </template>
      <template v-if="showCardStep === 3">
        <!-- <AdCommonFormLock
          :lockObj="lockObj"
          :mode="mode"
          @go-back="$emit('go-back')"
          @previous-step="handlePreviousStep"
        ></AdCommonFormLock>-->
      </template>
      <template v-if="showCardStep === 4">
        <MaterialCreativeAddForm :orderScheduleForm="orderScheduleForm" @go-back="$emit('go-back')"></MaterialCreativeAddForm>
      </template>
    </el-row>
  </div>
</template>
<script>
import CommonStep from '@/components/common/CommonStep'
import AdCommonForm from '@/components/AdCommonForm'
import AdCommonOrderForm from '@/components/AdCommonOrderForm'
import MaterialCreativeAddForm from '../creative/MaterialCreativeAddForm'
import CommonSelectPannel from '@/components/scheduleDirection/CommonSelectPannel'
import MultiAutoComplete from '@/components/MultiAutoComplete.vue'
export default {
  components: {
    AdCommonForm,
    CommonStep,
    AdCommonOrderForm,
    MaterialCreativeAddForm,
    CommonSelectPannel,
    MultiAutoComplete
  },
  inject: ['projectOrder'],
  data() {
    var totalCheck = (rule, val, callback) => {
      if (this.orderForm.sellingType === 1) {
        if (this.orderForm.totalContractType === 1) {
          return callback()
        }
        if (!val) {
          callback(new Error('请输入正确的下单总量'))
        } else {
          if (!Number.isInteger(val * 1) || val * 1 < 0) {
            callback(new Error('请输入正整数'))
          } else {
            if (val > 2000000000) {
              callback(new Error('下单总量不能超过2,000,000,000,请重新输入'))
            } else {
              callback()
            }
          }
        }
      } else {
        callback()
      }
    }
    var orderTagCheck = (rule, val, callback) => {
      const checkInfo = this.handleCheckRequiredTag()
      if (!checkInfo.status) {
        return callback(new Error(checkInfo.message))
      }
      if (this.handleOrderTag(val).length > 50) {
        return callback(new Error('最多只能选择50个标签'))
      }
      const errorInfo = this.validateTagRule()
      if (errorInfo) {
        return callback(new Error(errorInfo))
      }
      callback()
    }
    var customerBrandsCheck = (rule, val, callback) => {
      if (!val || val.length === 0) {
        callback(new Error('客户品牌必填'))
      } else {
        callback()
      }
    }
    var customerProductsCheck = (rule, val, callback) => {
      if (!val || val.length === 0) {
        callback(new Error('客户产品必填'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      mode: 'create',
      createType: 'newTab',
      showCardStep: 1,
      isShowParent: false, // 是否有广告主
      buttonLoading: false,
      options: [],
      contractTime: [], // 合约时间
      adSalesmanIdList: [],
      tagList: [],
      orderForm: {
        orderName: '',
        partnerId: '',
        buyType: '',
        contractBeginDate: '',
        contractEndDate: '',
        totalContractType: 1,
        totalContract: '',
        description: '',
        ipFilter: 0,
        iesSwitch: 0,
        orderId: '',
        dayBudget: null,
        orderTag: [],
        sellingType: 1,
        pushAuto: 0,
        adSalesmanIdList: [],
        customerBrands: [], // 客户品牌
        customerProducts: [] // 客户产品
      },
      rules: {
        orderName: [{ required: true, message: '请输入订单名称', trigger: 'blur' }],
        totalContract: [{ validator: totalCheck, trigger: 'change' }],
        orderTag: [{ type: 'array', validator: orderTagCheck, trigger: 'change' }],
        customerBrands: [{ type: 'array', validator: customerBrandsCheck, trigger: 'change' }],
        customerProducts: [{ type: 'array', validator: customerProductsCheck, trigger: 'change' }]
      }, // 订单名称和日预算需要校验
      commonForm: {}, // 订单到计划单参数
      scheduleForm: {}, // 用于锁量返回计划单
      lockObj: {}, // 锁量数据
      isLockPreviousStep: false, // 是否上一步返回
      isCollapse: false,
      isShowCommonForm: false,
      orderScheduleForm: {}, // 新增素材参数
      onePriceVisible: false,
      removeSpaceList: [],
      salesmanList: [],
      stepList: [
        {
          parent: '项目订单',
          status: '1',
          children: [
            {
              label: '订单设置',
              status: '1'
            }
          ]
        },
        {
          parent: '投放计划',
          status: '0',
          children: [
            {
              label: '基础设置',
              status: '0'
            },
            {
              label: '投放设置',
              status: '0'
            },
            {
              label: '定向',
              status: '0'
            },
            {
              label: '计划名称',
              status: '0'
            }
          ]
        },
        {
          parent: '素材创意',
          status: '0',
          children: [
            {
              label: '素材上传',
              status: '0'
            }
          ]
        }
      ],
      editStepList: [
        {
          parent: '项目订单',
          status: '1',
          children: [
            {
              label: '编辑订单',
              status: '1'
            }
          ]
        },
        {
          parent: '投放计划',
          status: '0',
          children: [
            {
              label: '基础设置',
              status: '0'
            },
            {
              label: '投放设置',
              status: '0'
            },
            {
              label: '排期与预算',
              status: '0'
            },
            {
              label: '计划名称',
              status: '0'
            }
          ]
        },
        {
          parent: '素材创意',
          status: '0',
          children: [
            {
              label: '素材上传',
              status: '0'
            }
          ]
        }
      ],
      oldSpaceTable: [],
      saveBtnLoading: false,
      translateSellTypeText: [],
      cableCheckable: true,
      schduleTime: {}
    }
  },
  props: ['initMode', 'id'],
  watch: {},
  computed: {
    nextStepDisable() {
      let disable = true
      if (this.isShowParent) {
        if (this.orderForm.orderName && this.orderForm.partnerId) {
          disable = false
        }
      } else {
        if (this.orderForm.orderName) {
          disable = false
        }
      }
      return disable
    },
    saveDisable() {
      if (this.orderForm.orderName === '') {
        return true
      }
      if (
        this.orderForm.buyType === 0 &&
        (this.contractTime === null || this.contractTime.length === 0)
      ) {
        return true
      }
      return false
    },
    noSaleman() {
      return this.orderForm.partnerId ? '无匹配数据' : '请先选择广告主'
    }
  },
  methods: {
    handleContractTime(val) {
      if (val) {
        // 开始时间不能晚于计划单开始时间，结束时间不能早于计划单结束时间
        const oldBeginDate = this.oldForm.contractBeginDate
        const selectedBegin = this.$moment(val[0]).format('YYYY-MM-DD')
        const selectEnd = this.$moment(val[1]).format('YYYY-MM-DD')

        if (this.schduleTime.begin && this.schduleTime.end) {
          const scheduleBeginDate = this.$moment(this.schduleTime.begin).format('YYYY-MM-DD')
          const scheduleEndDate = this.$moment(this.schduleTime.end).format('YYYY-MM-DD')
          this.orderForm.contractBeginDate = this.$moment(selectedBegin).isAfter(scheduleBeginDate) ? oldBeginDate : selectedBegin
          this.orderForm.contractEndDate = this.$moment(selectEnd).isBefore(scheduleEndDate) ? scheduleEndDate : selectEnd
        } else {
          this.orderForm.contractBeginDate = selectedBegin
          this.orderForm.contractEndDate = selectEnd
        }
        this.contractTime = [
          this.orderForm.contractBeginDate,
          this.orderForm.contractEndDate
        ]
      } else {
        this.orderForm.contractBeginDate = ''
        this.orderForm.contractEndDate = ''
      }
    },
    handleCancel() {
      const newForm = this.handleForm(this.orderForm)
      const isChange = this.$consts.difference(newForm, this.oldForm)
      if (Object.keys(isChange).length === 0) {
        this.$emit('go-back')
      } else {
        this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
          confirmButtonText: '离开页面',
          cancelButtonText: '留在页面',
          center: true,
          type: 'warning'
        })
          .then(() => {
            this.$emit('go-back')
          })
          .catch(() => {})
      }
    },
    handleOrderName(val) {
      let newValue = val.replace(/\s+/g, '')
      this.orderForm.orderName = newValue.replace(
        // eslint-disable-next-line
        /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\·\~\！\@\#\¥\%\……\&\*\（\）\——\-\+\=\【\】\{\}\、\|\；\‘\’\：\“\”\《\》\？\，\。\、\`\~\!\#\$\%\^\&\*\(\)\_\[\]{\}\\\|\;\'\'\:\"\"\,\.\/\<\>\?\+\$]/g,
        ''
      )
    },
    // 订单下一步
    goNextStep(data) {
      this.commonForm = {
        orderId: data.orderId,
        orderNo: data.orderNo,
        orderName: data.orderName,
        partnerId: data.partnerId,
        partnerName: data.partnerName,
        buyType: data.buyType,
        sellingType: data.sellingType,
        iesSwitch: data.iesSwitch,
        contractBeginDate: new Date(this.$moment(data.contractBeginDate).format('YYYY-MM-DD 00:00:00')).getTime(),
        contractEndDate: new Date(this.$moment(data.contractEndDate).format('YYYY-MM-DD 23:59:59')).getTime()
      }
      this.getCableCheckable(data.partnerId)
      this.showCardStep = 2
      this.handleChangeStepStatus()
    },
    getCableCheckable(partnerId) {
      const params = {
        cableNo: 'IQIYI',
        partnerId: partnerId
      }
      this.$service.getCabelStatus(params).then(res => {
        this.cableCheckable = res.data === 0
      })
    },
    // 第三步，锁量确认
    getStep(data) {
      this.showCardStep = 3
      this.lockObj = {
        form: data[0],
        tableData: data[1],
        collapseDevice: data[2],
        sizeOptions: data[3],
        beforeChangeTotalTraffic: data[4],
        beforeChangeBudegtCost: data[5],
        order: data[6]
      }
    },
    // 锁量返回上一步
    handlePreviousStep(data) {
      this.scheduleForm = data.form
      this.order = data.order
      this.showCardStep = 2
      this.isLockPreviousStep = true
    },
    // 锁量添加素材
    handleAddMedia(data) {
      this.showCardStep = 4
      this.orderScheduleForm = data
      this.handleChangeStepStatus()
    },
    // 改变左侧步骤条状态
    handleChangeStepStatus() {
      let index = this.stepList.findIndex((item) => item.status === '1')
      this.stepList[index].status = '2'
      this.stepList[index].children.forEach((item) => {
        item.status = '2'
      })
      this.stepList[index + 1].status = '1'
      this.stepList[index + 1].children[0].status = '1'
    },
    // 判断选择时间是否小于当前时间
    // testDate() {
    //   let _now = new Date()
    //   if (this.contractTime[0] < _now) {
    //     this.contractTime[0] = _now
    //   }
    //   if (this.contractTime[1] < _now) {
    //     this.contractTime[1] = _now
    //   }
    // },
    // 编辑页面方法
    onEditSubmit(formName, way) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveBtnLoading = true
          let form = this.handleForm(this.orderForm)
          this.$service
            .saveEditOrder(form, '操作成功')
            .then((res) => {
              this.saveBtnLoading = false
              if (way === 'back') {
                this.$emit('go-back')
              } else if (way === 'batch') {
                this.$router.push({
                  name: 'batchOrder',
                  params: {
                    orderId: this.orderForm.orderId
                  }
                })
              } else {
                let order = {
                  orderId: this.orderForm.orderId,
                  orderNo: this.orderForm.orderNo,
                  orderName: this.orderForm.orderName,
                  partnerId: this.orderForm.partnerId,
                  partnerName: this.orderForm.partnerName,
                  buyType: this.orderForm.buyType,
                  sellingType: this.orderForm.sellingType,
                  iesSwitch: this.orderForm.iesSwitch,
                  contractBeginDate: this.orderForm.contractBeginDate,
                  contractEndDate: this.orderForm.contractEndDate
                }
                this.goNextStep(order)
              }
            })
            .catch((e) => {
              this.saveBtnLoading = false
            })
        } else {
          return false
        }
      })
    },
    handleOrderTag(val) {
      let tags = []
      val.forEach((item) => {
        // 全选了一级
        if (item.children) {
          // 需要把所有的子级拿出来,放到tags里面
          tags = tags.concat(
            item.children.map((e) => {
              return e.value.split('-')[1]
            })
          )
        } else {
          tags.push(item.value.split('-')[1])
        }
      })
      return tags
    },
    handleCheckRequiredTag() {
      const allRequiredTagsList = this.tagList.filter((item) => item.isRequired === 1)
      if (allRequiredTagsList.length === 0) {
        return { status: true }
      } else {
        let isSelectd = []
        this.orderForm.orderTag.forEach((item) => {
          if (item.children) {
            isSelectd = isSelectd.concat(item.value)
          } else {
            isSelectd.push(parseInt(item.value.split('-')[0]))
          }
        })
        const isRequiredNotSelect = []
        allRequiredTagsList.forEach((item) => {
          if (isSelectd.indexOf(item.value) === -1) {
            isRequiredNotSelect.push(item.label)
          }
        })
        if (isRequiredNotSelect.length === 0) {
          return { status: true }
        } else {
          return {
            status: false,
            message: '请选择' + isRequiredNotSelect.join()
          }
        }
      }
    },
    validateTagRule() {
      const singleCheckedTags = this.tagList.filter(item => item.validationRule === 1)
      const checkedTagsMap = new Map()
      this.orderForm.orderTag.forEach(item => {
        if (typeof item.value === 'string' && item.value.indexOf('-') > 0) {
          const typeId = parseInt(item.value.split('-')[0])
          checkedTagsMap.has(typeId) ? checkedTagsMap.set(typeId, checkedTagsMap.get(typeId) + 1) : checkedTagsMap.set(typeId, 1)
        } else {
          checkedTagsMap.set(item.value, (item.children ? item.children.length : 0))
        }
      })
      const invalidTagTypes = []
      checkedTagsMap.forEach((value, key, map) => {
        const curTag = singleCheckedTags.find(tag => tag.value === key)
        if (curTag && value > 1) {
          invalidTagTypes.push(curTag.label)
        }
      })
      if (invalidTagTypes.length > 0) {
        return `标签 ${invalidTagTypes.join('、')} 为单选项`
      }
    },
    // 格式化表单，提及后台
    handleForm(form) {
      const orderTags = this.handleOrderTag(form.orderTag)
      const formData = {
        adSalesmanIdList: form.adSalesmanIdList,
        buyType: form.buyType,
        contractBeginDate: form.contractBeginDate,
        contractEndDate: form.contractEndDate,
        contractSn: form.contractSn,
        dayBudget: form.dayBudget,
        description: form.description,
        ipFilter: form.ipFilter,
        iesSwitch: form.iesSwitch,
        orderId: form.orderId,
        orderName: form.orderName,
        orderTag: orderTags.join(','),
        partnerId: form.partnerId,
        sellingType: form.sellingType,
        totalContractType: form.totalContractType,
        totalContract: (form.sellingType === 1 && form.totalContract) ? form.totalContract : 0,
        customerBrands: form.customerBrands,
        pushAuto: form.pushAuto,
        customerProducts: form.customerProducts
      }
      return formData
    },
    // 获取单个订单数据
    getOrderById() {
      this.$service.getOrderById({ id: this.id }).then((data) => {
        this.orderForm.orderName = data.orderName
        this.orderForm.partnerId = data.partnerId || this.projectOrder.partnerId
        this.orderForm.partnerName = data.adDspPartner.partnerName
        this.orderForm.buyType = data.buyType
        this.orderForm.contractBeginDate = data.contractBeginDate
        this.orderForm.contractEndDate = data.contractEndDate
        this.orderForm.totalContractType = data.totalContractType
        this.orderForm.totalContract = data.totalContract
        this.orderForm.description = data.description
        this.orderForm.ipFilter = data.ipFilter
        this.orderForm.iesSwitch = data.iesSwitch
        this.orderForm.sellingType = data.sellingType
        this.orderForm.orderId = data.orderId
        this.orderForm.dayBudget = null
        this.orderForm.customerBrands = data.customerBrands
        this.orderForm.customerProducts = data.customerProducts
        this.contractTime = [
          this.orderForm.contractBeginDate,
          this.orderForm.contractEndDate
        ]
        this.orderForm.orderTag = this.handleReviewOrderTags(data.orderTag)
        this.orderForm.pushAuto = data.pushAuto
        this.initSales(this.orderForm.partnerId).then((res) => {
          data.adSalesmanList.forEach((item) => {
            if (res.some(({ agentAccountId }) => agentAccountId === item.salesmanId)) {
              this.adSalesmanIdList.push(item.salesmanId)
            }
          })
          this.orderForm.adSalesmanIdList = JSON.parse(
            JSON.stringify(this.adSalesmanIdList)
          )
          this.oldForm = this.handleForm(this.orderForm)
        })
      })
    },
    handleReviewOrderTags(data) {
      const tags = data !== '' ? data.split(',') : []
      let tagList = []
      let reviewTags = []
      // 将数组转为一维数组
      this.tagList.forEach((item) => {
        tagList = tagList.concat(item.children)
      })
      tags.forEach((item) => {
        const index = tagList.findIndex((e) => e.value.split('-')[1] === item)
        if (index > -1) {
          reviewTags.push({
            label: tagList[index].label,
            value: tagList[index].value
          })
        }
      })
      return reviewTags
    },
    onScroll() {
      let scrolled = document.getElementById('rightForm').scrollTop
      this.stepList[1].children.forEach((item) => {
        item.status = '0'
      })
      if (scrolled < 459) {
        this.stepList[1].children[0].status = '1'
      } else if (scrolled >= 459 && scrolled < 786) {
        this.stepList[1].children[1].status = '1'
      } else if (scrolled >= 786 && scrolled < 1185) {
        this.stepList[1].children[2].status = '1'
      } else {
        this.stepList[1].children[3].status = '1'
      }
    },
    handleScroll(data) {
      let height = document.getElementById(data.label)
      if (height) {
        let total = height.offsetTop
        document.getElementById('rightForm').scrollTo({
          top: total,
          behavior: 'smooth'
        })
      }
    },
    // 获取业务员数据
    initSales(partnerId) {
      return new Promise((resolve, reject) => {
        this.$service.getSalesmanList({ partnerId: partnerId }).then((res) => {
          if (Array.isArray(res || [])) {
            this.salesmanList = res || []
          } else {
            this.salesmanList = []
          }
          resolve(this.salesmanList)
        })
      })
    },
    // 获取订单标签
    getOrderTags() {
      return new Promise((resolve, reject) => {
        this.$service.getOrderTags().then((data) => {
          this.tagList = data.map((item) => {
            return {
              label: item.mediaTagTypeName,
              value: item.mediaTagTypeId,
              isRequired: item.isRequired,
              validationRule: item.validationRule,
              children: item.mediaTagsList.map((e) => {
                return {
                  label: e.mediaTagName,
                  value: item.mediaTagTypeId + '-' + e.mediaTagId // 子级value需要拼接
                }
              })
            }
          })
          resolve(this.tagList)
        })
      })
    },
    // 获取售卖价格
    getSellTypes() {
      this.$service.queryDictData({ type: 'selling_type' }).then((res) => {
        this.translateSellTypeText = (res || []).reduce(
          (result, item) => {
            result[item.value] = item.label
            return result
          },
          { '': '-' }
        )
      })
    },
    getScheduleTime() {
      const params = { orderId: this.id }
      this.$service.getOrderTime(params).then(res => {
        this.schduleTime = res
      })
    },
    disabledDate(time) {
      const yesterday = Date.now() - 8.64e7
      if (this.mode === 'edit' && this.schduleTime.begin && this.schduleTime.end) {
        const schduleBeginTime = this.$moment(this.schduleTime.begin)
        const schduleEndTime = this.$moment(this.schduleTime.end)
        const timeMoment = this.$moment(time)
        return time.getTime() < yesterday || (timeMoment.isAfter(schduleBeginTime) && timeMoment.isBefore(schduleEndTime))
      }
      return time.getTime() < yesterday
    },
    totalContractTypeChange() {
      this.orderForm.totalContract = undefined
      this.$refs.orderForm.validateField('totalContract')
    }
  },
  mounted() {
    let box = document.getElementById('rightForm')
    box.addEventListener('scroll', () => {
      this.onScroll()
    })
  },
  created() {
    this.$bus.$on('stepChange', (event) => {
      this.handleScroll(event)
    })
    this.mode = this.initMode || 'create'
    if (this.mode === 'edit') {
      this.getOrderTags().then((res) => {
        this.getOrderById()
        // 获取订单下计划单时间边界
        this.getScheduleTime()
      })
      this.getSellTypes()
    }
    if (this.projectOrder.accountType === '1') {
      this.isShowParent = true
    } else {
      this.isShowParent = false
      this.orderForm.partnerId = this.projectOrder.partnerId
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  display flex
  flex-direction row
  height 100%
.content-2-col
  width calc(100% - 132px)
  padding 16px
  overflow auto
.demo-ruleForm >>>.el-form-item
  max-width 800px
.edit-page
  overflow hidden
  height calc(100vh - 60px)
>>>.el-select
  display block
>>>.el-input-group__prepend, >>>.el-input-group__append
  background-color #fff
  color #606266
.flex-form-item >>> .el-form-item__content
  display flex
  .el-radio-group
    flex-shrink 0
    margin-right 20px
</style>
